import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './NoSurveys.module.scss';
import SurveyMagnifier from 'components/assets/SurveyMagnifier.svg';
import PushNotificationsCard from 'components/organisms/PushNotifications/PushNotificationsCard';
import { useNoSurveysFragmentQuery } from './useNoSurveysFragmentQuery';
import { useNoSurveysFragmentQuery_noSurveysRef$key } from './__generated__/useNoSurveysFragmentQuery_noSurveysRef.graphql';

export type NoSurveysProps = {
  readonly noSurveysRef: useNoSurveysFragmentQuery_noSurveysRef$key;
  readonly onFiltersChanged?: (key: string) => void;
  readonly filterActiveMap?: Record<string, boolean>;
};

export default function NoSurveys({ noSurveysRef, onFiltersChanged }: Readonly<NoSurveysProps>) {
  const data = useNoSurveysFragmentQuery(noSurveysRef);

  const userName = data.userData?.firstName;

  return (
    <div className={classes.fullWidth}>
      <Heading level={3}>Hey, {userName ? { userName: userName } : 'there'}</Heading>
      <Txt size="large" component="p" className={classes.noSurveysText}>
        We don&apos;t seem to have any surveys for you right now.
      </Txt>
      <SurveyMagnifier width={98} height={85} />
      <Txt component="p" className={classes.noSurveysSecondaryText}>
        We are always looking out for the best surveys, so check back later, we&apos;re sure to find
        some soon.
      </Txt>

      <PushNotificationsCard pushNotificationsRef={data.notificationSubscriptions} />
    </div>
  );
}
